export { default } from "./CartList"
